// removed by extract-text-webpack-plugin
module.exports = {"container":"_2raBIF0CH8UhGp0y0k81TJ"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c08ee662","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/SearchContacts/SearchMode/ContactsComponent.less
// module id = mdIU
// module chunks = 1